import { Component, Mixins, Watch } from 'vue-property-decorator'
import { VDialog } from 'vuetify/lib/components/VDialog'
import Modals from '@ustra/nuxt/src/vue/mixins/modal'

@Component
export default class extends Mixins(Modals, VDialog) {
  // #region variables
  // #endregion
  // #region hooks
  // #endregion
  // #region methods
  hide() {
    this.$emit('input', false)
  }

  @Watch('value')
  valueChanged(value: boolean) {
    if (value) {
      // @ts-ignore
      Modals.options.methods._showModal.call(this)
    } else {
      // @ts-ignore
      Modals.options.methods._hideModal.call(this)
    }
  }
  // #endregion
  // #region watches
  // #endregion
}
